const GTag = {
	async install(Vue, options) {
		let enabled = false;

		function load() {
			if (enabled) return;

			enabled = true;

			const script = document.createElement("script");

			script.async = true;
			script.src = `https://www.googletagmanager.com/gtag/js?id=${options.id}`;

			gtag("js", new Date());
			gtag("config", options.id);

			document.body.appendChild(script);
		}

		function gtag() {
			const dataLayer = (window.dataLayer = window.dataLayer || []);

            dataLayer.push(arguments);
		}

		Vue.prototype.$gtag = {
			enable: load,
			conversion: args => {
                if (!args.event_callback) {
                    args.event_callback = () => {};
                }

                if (!enabled) {
                    args.event_callback();
                }

				gtag("event", "conversion", args);

                setTimeout(() => {
                    args.event_callback();
                }, 2000);
			},
		};
	},
};

export default GTag;
